export default [
    {
        title: "Design",
        text: "We believe in the importance of establishing a brand identity for your company that represents your business the way you want it to be seen.",
        link: "/design"
    },
    {
        title: "Development",
        text: "Our team of skilled professionals is well-versed in how to identify mistakes and combat them quickly so that your store can be as successful as possible.",
        link: "/development"
    },
    {
        title: "SEO",
        text: "At Shopify Systems, our team of agents guarantees is trained to create high SEO scores so that your store can be comprehensive and lightning fast.",
        link: "/seo"
    },
]